var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-layout form-layout-4" },
      [[_vm._m(0), _vm._v(" "), _vm._m(1)]],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", [_c("b", [_vm._v("Wat is 2FA?")])]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\n                            Twee-factor-authenticatie (2FA) is een extra beveiligingslaag naast je gebruikersnaam en wachtwoord. Bij het inloggen op Bontrooster.nl moet je niet alleen je wachtwoord invullen, maar ook een extra code die je op je telefoon ontvangt. Zo zorgen we ervoor dat alleen jij kunt inloggen op jouw account, ook als iemand anders je wachtwoord weet.\n                        "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                            Deze extra beveiliging is belangrijk, omdat in BONTrooster persoonsgegevens en gevoelige informatie van jongeren is opgeslagen. Met 2FA verkleinen we de kans op misbruik van accounts.\n                        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mg-b-10" }, [
          _c("b", [_vm._v("Hoe stel je 2FA in via QR Code?")])
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "list-group  list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              "1. Download de Google Authenticator app op je telefoon (of een andere authenticator app)."
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              "2. Log via je laptop in op bontrooster.nl met je gebruikersnaam en wachtwoord."
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              "\n                                3. Bovenin het scherm zie je onderstaande melding.\n                                "
            ),
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: "images/Totp_help.png", alt: "Logo" }
            })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("4. Klik op “klik hier”.")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              "5. Open de Google Authenticator app op je telefoon en scan de QR code."
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              "6. Vul de code in die in de Authenticator app staat en klik op opslaan."
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("7. Nu is de 2FA ingesteld!")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", [_c("b", [_vm._v("Hoe stel je 2FA in via handmatige Code?")])]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                            Bij het instellen van 2-stapsverificatie geeft de website meestal "
          ),
          _c("b", [
            _vm._v(
              'ook een optie om een "sleutel" of "code" handmatig in te voeren '
            )
          ]),
          _vm._v(
            "in plaats van het scannen van de QR-code. Hier is hoe je dat doet:\n                        "
          )
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "list-group  list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("1. Kies op de website waar je 2FA instelt voor "),
            _c("b", [_vm._v('"Kan je de QR-code niet scannen?"')]),
            _vm._v(" of iets vergelijkbaars.")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("2. Je krijgt dan een "),
            _c("b", [_vm._v("handmatige instelcode")]),
            _vm._v(" (ook wel “tijdsgebaseerde sleutel” genoemd).")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("\n                                3. Open de "),
            _c("b", [_vm._v("Google Authenticator-app")]),
            _vm._v(" op je telefoon.\n")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("4. Tik op het "),
            _c("b", [_vm._v('"+"-icoontje ')]),
            _vm._v("(rechtsonder).")
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("5. Kies "),
            _c("b", [_vm._v('"Sleutel invoeren"')]),
            _vm._v(' of "Voer een instelcode in".')
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v(
              '6. Geef het account een naam (bijv. "Mijn Google Account") en voer de sleutel in.'
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("7. Tik op "),
            _c("b", [_vm._v("Toevoegen")]),
            _vm._v(". Je krijgt nu de 2FA-codes te zien.")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }